// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NomCommande_wrapper__2cGrd","loading":"NomCommande_loading__1_yjJ","picto":"NomCommande_picto__29Qmb","input":"NomCommande_input__3LCdZ"};